// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

// project import
import MainCard from "../../components/mainCard";
import LogoLogin from "../../components/logo/logoLoginNew";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { PAGE_LOGIN } from "../../../../locales/pages/namespaces";
import { useLocation } from "react-router";
import { getRouteUrl } from "../../../../helpers/getRouteUrl";
import { ROUTE_PAGE_LOGIN } from "../../../../routers/routes";
import ArrowLeftIcon from "../../../../assets/images/icons/buttonsIcons/arrowLeftIcon";
import React from "react";
import useUserAction from "../../../../hooks/user/useUserAction";
import { useHistory } from "react-router-dom";

// ==============================|| AUTHENTICATION - CARD WRAPPER ||============================== //

const AuthCard = ({ children, ...other }) => {
	const theme = useTheme();
	const location = useLocation()
	const { t } = useTranslation(PAGE_LOGIN)
	const { userLogout } = useUserAction()
	const history = useHistory()

	const isSignUp = location.pathname === '/signup'

	return (
		<div style={{ fontFamily: 'IMS' }}>
			<div
				className="force-ims"
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<Box sx={{ m: '0 0 25px 0' }}>
					<LogoLogin  width={'5.958rem'} height={'5.257rem'} />
				</Box>
				<MainCard
					sx={{
						textAlign: 'center',
						maxWidth: { xs: '100%', lg: 400 },
						p: '0 24px',
					}}
					content={false}
					{...other}
					border={true}
					className='border-neutral-dark'
				>
					<Typography variant={'h5'} className='color-default title-sm' sx={{ m: '32px 0 24px 0' }}>
						{t('Login to your account')}
					</Typography>
					<Box>{children}</Box>
				</MainCard>

			</div>
		</div>

	);
};

export default AuthCard;